export default __webpack_public_path__ + "static/media/330_business04-it-web.d3d408d9.png";